import Auth from "@aws-amplify/auth";
import { Container, createStyles } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useSnackbar } from "notistack";
import React from "react";
import SignInRedirect from "../components/Auth/SignInRedirect";
import Loader from "../components/Loading/Loader";
import Logo from "../components/Logo";
import { isUserAuthorized, ROLES } from "../constants";
import useUser from "../hooks/useUser";

interface Props {}

const useStyles = makeStyles(
  createStyles({
    root: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
    },
    img: {
      maxWidth: 700,
      maxHeight: 500,
      width: "80%",
      height: "40%",
    },
  })
);

const Authentication: React.FC<Props> = ({ children }) => {
  const classes = useStyles();
  const { loading, groups = [], user } = useUser();
  const isAuthorized = React.useMemo(
    () => isUserAuthorized(groups, [ROLES.ADMIN]),
    [groups]
  );

  const { enqueueSnackbar } = useSnackbar();

  React.useEffect(() => {
    if (loading) {
      return;
    }
    if (!!user && !isAuthorized) {
      Auth.signOut().then(() => {
        enqueueSnackbar("Sie sind kein Administrator!", { variant: "error" });
      });
    }
  }, [isAuthorized, user, loading, enqueueSnackbar]);

  if (loading) {
    return (
      <Container className={classes.root}>
        <Logo className={classes.img} />
        <Loader />
      </Container>
    );
  }
  if (!user || !isAuthorized) {
    return <SignInRedirect />;
  }

  if (children) {
    return <>{children}</>;
  } else return null;
};

export default Authentication;
